import { useEffect } from 'react';
import Router from 'core/routing';
import WebFont from 'webfontloader';
import theme from 'core/theme';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider as MuiPickerProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from 'core/contexts/localization';
import getDatepickerLocale from 'core/locales/getDatepickerLocale';
import { CheckoutProvider } from 'core/contexts/checkout';
import { StripeProvider } from 'core/contexts/stripe';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'antd/dist/antd.css';
import { UserProvider } from 'core/contexts/user';

const App = () => {
    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Mina', 'Mina:bold'],
            },
        });

    }, []);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <MuiPickerProvider dateAdapter={AdapterDateFns} adapterLocale={getDatepickerLocale()}>
                    <LocalizationProvider>
                        <StripeProvider>
                            <CheckoutProvider>
                                <UserProvider>
                                    <Router />
                                </UserProvider>
                            </CheckoutProvider>
                        </StripeProvider>
                    </LocalizationProvider>
                    <ToastContainer />
                </MuiPickerProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
